import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { TooltipPositions, TooltipAlign, } from "./constants";
const { color, text, size } = ids || {};
const getContainerPosition = (position, align) => {
    switch (position) {
        case TooltipPositions.down:
            return css `
        top: calc(100% + ${size.general.ids_size_general_12x});
        ${align === TooltipAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === TooltipAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
          transform: translate(-50%);`}
      `;
        case TooltipPositions.top:
            return css `
        bottom: calc(100% + ${size.general.ids_size_general_12x});
        ${align === TooltipAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === TooltipAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
          transform: translate(-50%);`}
      `;
        case TooltipPositions.left:
            return css `
        top: 50%;
        transform: translate(0, -50%);
        right: calc(100% + ${size.general.ids_size_general_12x});
      `;
        case TooltipPositions.right:
            return css `
        top: 50%;
        transform: translate(0, -50%);
        left: calc(100% + ${size.general.ids_size_general_12x});
      `;
        default:
            return css `
        bottom: calc(100% + ${size.general.ids_size_general_12x});
        ${align === TooltipAlign.left
                ? `left: -${size.general.ids_size_general_12x};`
                : align === TooltipAlign.right
                    ? `right: -${size.general.ids_size_general_12x};`
                    : `left: 50%;
          transform: translate(-50%);`}
      `;
    }
};
const getArrowPosition = (position) => {
    switch (position) {
        case TooltipPositions.down:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-bottom-color: ${color.feedbacks.ids_color_feedback_information};
        top: -${size.general.ids_size_general_16x};
      `;
        case TooltipPositions.top:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-top-color: ${color.feedbacks.ids_color_feedback_information};
        bottom: -${size.general.ids_size_general_16x};
      `;
        case TooltipPositions.left:
            return css `
        border-bottom: ${size.general.ids_size_general_6x} solid transparent;
        border-top: ${size.general.ids_size_general_6x} solid transparent;
        border-left-color: ${color.feedbacks.ids_color_feedback_information};
        right: -${size.general.ids_size_general_16x};
      `;
        case TooltipPositions.right:
            return css `
        border-bottom: ${size.general.ids_size_general_6x} solid transparent;
        border-top: ${size.general.ids_size_general_6x} solid transparent;
        border-right-color: ${color.feedbacks.ids_color_feedback_information};
        left: -${size.general.ids_size_general_16x};
      `;
        default:
            return css `
        border-right: ${size.general.ids_size_general_6x} solid transparent;
        border-left: ${size.general.ids_size_general_6x} solid transparent;
        border-top-color: ${color.feedbacks.ids_color_feedback_information};
        bottom: -${size.general.ids_size_general_16x};
      `;
    }
};
const getArrowAlign = (align, position) => {
    if (position === TooltipPositions.top || position === TooltipPositions.down)
        switch (align) {
            case TooltipAlign.left:
                return css `
          left: ${size.general.ids_size_general_18x};
        `;
            case TooltipAlign.right:
                return css `
          right: ${size.general.ids_size_general_18x};
        `;
            case TooltipAlign.middle:
                return css `
          left: 50%;
          transform: translate(-50%);
        `;
        }
    return css `
    top: 50%;
    transform: translate(0, -50%);
  `;
};
export const StyledTooltipContainer = styled.div `
  position: absolute;
  width: max-content;
  z-index: 1;
  ${({ position, align }) => getContainerPosition(position, align)}
`;
export const StyledTooltipBox = styled.div `
  position: relative;
  align-items: center;
  background-color: ${color.feedbacks.ids_color_feedback_information};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_tooltip};
  color: ${color.contrast.ids_color_contrast_onDark};
  display: flex;
  font: ${text.label.ids_textStyle_label_small_regular};
  line-height: rem(17.5);
  max-width: calc(
    ${size.general.ids_size_general_112x} +
      ${size.general.ids_size_general_100x}
  );
  padding: ${size.general.ids_size_general_12x};
`;
export const StyledTooltipArrow = styled.div `
  position: absolute;
  border: ${size.general.ids_size_general_8x} solid transparent;
  ${({ position }) => getArrowPosition(position)}
  ${({ align, position }) => getArrowAlign(align, position)}
`;
export const StyledTooltip = styled.div `
  position: relative;
  width: fit-content;
  .tooltip-container {
    display: none;
  }
  &:hover {
    .tooltip-container {
      display: flex;
    }
  }
`;
//# sourceMappingURL=Tooltip.style.js.map